import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import PopoverAnchor from './PopoverAnchor';
import ShellIcon from './ShellIcon';
import { SHELL_LANGUAGES, ShellLanguage } from './language';
import menuItems from './popoverItems.module.scss';
import styles from './LanguageMenu.module.scss';

interface LanguageMenuProps {
  language: ShellLanguage;
  onLanguageChange: (language: ShellLanguage) => void;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  /** Widoczny także na telefonie (ekrany /auth nie mają menu konta, do którego język przechodzi). */
  persistent?: boolean;
}

/** Przełącznik języka w nagłówku („PL ▾”); na telefonie język jest w menu konta. */
const LanguageMenu: FunctionComponent<LanguageMenuProps> = ({
  language,
  onLanguageChange,
  open,
  onOpenChange,
  persistent = false,
}) => {
  const { t } = useTranslation(['dashboard']);
  const label = t('dashboard:shell.language.label');

  return (
    <PopoverAnchor
      open={open}
      onOpenChange={onOpenChange}
      popupType="menu"
      align="end"
      label={label}
      anchorClassName={persistent ? styles.anchorPersistent : styles.anchor}
      renderTrigger={(triggerProps) => (
        <button type="button" className={styles.trigger} {...triggerProps}>
          <span className={styles.srOnly}>{label}: </span>
          {language.toUpperCase()}
          <ShellIcon name="chevronDown" size={14} />
        </button>
      )}
    >
      {SHELL_LANGUAGES.map((code) => {
        const selected = code === language;

        return (
          <button
            key={code}
            type="button"
            role="menuitemradio"
            aria-checked={selected}
            data-popover-item
            className={`${menuItems.item} ${selected ? menuItems.selected : ''}`}
            onClick={() => {
              onLanguageChange(code);
              onOpenChange(false);
            }}
          >
            {t(`dashboard:shell.language.${code}`)}
            {selected && (
              <span className={menuItems.tick}>
                <ShellIcon name="check" />
              </span>
            )}
          </button>
        );
      })}
    </PopoverAnchor>
  );
};

export default LanguageMenu;
